export default __webpack_public_path__ + "static/media/2503289.7f0bd5c2.jpg";